import { defineComponent as _defineComponent } from 'vue'
import {useTranslations} from "@/hooks/useTranslations";
import SignupDto from "@/models/Restaurants/SignupDto";
import {getCurrentInstance, onMounted, ref} from "vue";
import {useNotify} from "@/hooks/useNotify";
import CustomersRepository from "@/utils/API/CustomersRepository";
import {MarketingParams} from "@/models/Subscriptions/MarketingParams";
import Industry from "@/models/Industry";
import Country from "@/models/Country";
import GeneralRepository from "@/utils/API/GeneralRepository";
import SubscriptionRepository from "@/utils/API/SubscriptionRepository";

type FreeTrialSignupFormProps = {
  marketingParams: MarketingParams;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FreeTrialSignupForm',
  props: {
    marketingParams: null
  },
  setup(__props: any) {

const props = __props as {
  marketingParams: MarketingParams;
};



const translations = useTranslations();
const { proxy } = getCurrentInstance();
const validator = proxy.$validator;
const notify = useNotify();

const signupFormData = ref<Omit<SignupDto, "marketingParams" | "shouldSkipFreeTrial" | "countryId" | "industryId">>({
  name: "",
  phone: "",
  ownerFirstName: "",
  ownerLastName: "",
  ownerEmail: "",
  ownerPassword: "",
  confirmOwnerPassword: "",
  referrer: "",
  hasRequestedNewsLetter: false
});
const phoneTouched = ref(false);
const invalidPhone = ref(false);
const agreeTerms = ref(false);
const passwordMinLength = ref(8);
const countryList = ref<Country[]>([]);
const industryList = ref<Industry[]>([]);

const selectedIndustry = ref<Industry>();
const selectedCountry = ref<Country>();

const freeTrialDays = ref<number>(0);

onMounted(async() => {
  await getTrialDays();
  countryList.value = (await GeneralRepository.listCountries()).data.result;
  industryList.value = (await GeneralRepository.listIndustries()).data.result;
});

async function getTrialDays() {
  try {
    const response = await SubscriptionRepository.getSubscriptionSystemSettings();
    freeTrialDays.value = response.data.result.trialDays;
  }

  catch (error: any) {
    notify.error(
      error.response
        ? error.response.errorMessages[0].userVisibleMessage
        : translations.value.get("network-error")
    );
  }
}

async function createAccount() {
  phoneTouched.value = true;

  const result = await validator.validateAll("accCreate");

  if (result && !invalidPhone.value) {
    if (!agreeTerms.value) {
      notify.error(translations.value.get("login_accept_terms_message"));
      return;
    }

    notify.info(translations.value.get("login_creating"));

    try {
      await signup();
      window.location = process.env.VUE_APP_THANKYOUPAGE_URL;
    }

    catch (error: any) {
      const message = error.response
        ? error.response.data.errorMessages[0].userVisibleMessage
        : translations.value.get("network_error");

      notify.error(message);
    }

    return;
  }

  notify.error(translations.value.get("validation-error-message"));
}

async function signup() {
  await CustomersRepository.signup({
    shouldSkipFreeTrial: false,
    countryId: selectedCountry.value.id,
    industryId: selectedIndustry.value.id,
    marketingParams: props.marketingParams,
    ...signupFormData.value,
  });
}

function handlePhoneValidation(response: any){
  invalidPhone.value = !response.isValid;
}

return { __sfc: true,props, translations, proxy, validator, notify, signupFormData, phoneTouched, invalidPhone, agreeTerms, passwordMinLength, countryList, industryList, selectedIndustry, selectedCountry, freeTrialDays, getTrialDays, createAccount, signup, handlePhoneValidation }
}

})